import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth/";
import { Router } from '@angular/router';
import { AngularFirestore, } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class AuthService {
	userData: any;
	notifyLogout = new Subject();

	constructor(
		public afs: AngularFirestore,
		public afAuth: AngularFireAuth,
		public router: Router,
	) {

		this.afAuth.authState.subscribe((user) => {
			if (user) {
				this.userData = user;
				localStorage.setItem('user', JSON.stringify(this.userData));
				JSON.parse(localStorage.getItem('user')!);
			} else {
				localStorage.setItem('user', 'null');
				JSON.parse(localStorage.getItem('user')!);
			}
		});
	}

	public isAuthenticated(): boolean {
		const email = sessionStorage.getItem('email');
		if (!email) {
			// this.router.navigate(['login']);
			return false;
		}
		return true;
	}

	public firebaseLogin(email, password) {
		return this.afAuth.auth.signInWithEmailAndPassword(email, password)
			.then((result) => {
				this.router.navigate(['admin']);
				this.funcSetAuthData(result.user);
				this.notifyLogout.next("");
			}).catch((error) => {
				window.alert(error.message)
			})
	}

	funcSetAuthData(data) {
		sessionStorage.setItem("email", data.email);
	}
}